import { DataTableAssign } from "@/components/custom/data-table/data-table-assign";
import { DataTableButtons } from "@/components/custom/data-table/buttons/data-table-buttons";
import { ModelSelectionTableContext } from "./model-selection-table-context";
import {
  ModelSelectionFilters,
  ModelSelectionFiltersInline,
} from "./model-selection-filters";

export function ModelSelectionTable({
  context,
  topExtra,
}: {
  context?: any;
  /** Rendered on the filters row, so it stays in view without scrolling past the table. */
  topExtra?: React.ReactNode;
}) {
  return (
    <DataTableAssign
      context={context || ModelSelectionTableContext}
      pageOptions={[10]}
      ShowPaginationOptions={{ showPerPage: false, showRefresh: false }}
      // The table is a flex column so the rows are the only part that scrolls: h-auto drops the
      // percentage height both boxes default to, which cannot shrink below its content.
      className="flex h-auto min-h-0 flex-1 flex-col"
      pagination={{ className: "flex-shrink-0" }}
      scroll={{
        className: "h-auto min-h-0 flex-1",
      }}
      top={() => (
        // The pagination block's height is observed and subtracted from the scroll area, so an
        // extra row here shortens the table instead of pushing it out of view.
        <div className="flex w-full flex-col gap-3">
          <div className="flex items-center gap-2">
            <DataTableButtons
              filters={ModelSelectionFilters}
              filtersInline={ModelSelectionFiltersInline}
              combineForms={true}
            />
          </div>
          {topExtra}
        </div>
      )}
    />
  );
}
